module.exports = __webpack_public_path__ + "static/media/model10.1164a40d.glb";